import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

/**
 * Generic modal (mockup `.modal` / `.modalcard` / `.x`). Becomes a bottom sheet ≤960px
 * (border-radius 18px 18px 0 0). Project body into the default slot; footer via
 * `[modal-footer]`.
 */
@Component({
  selector: 'app-modal',
  standalone: true,
  styleUrl: './modal.component.scss',
  imports: [CommonModule, A11yModule],
  templateUrl: './modal.component.html',
  
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
  @Input() show = false;
  @Input() set open(v: boolean) { this.show = v; }
  @Input() title = '';
  @Input() subtitle = '';
  /** Opt-in to a wider modal (e.g. the invoice-preview document). */
  @Input() wide = false;
  @Input() closeOnBackdrop = true;

  @Output() close = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void { if (this.show) this.emitClose(); }

  onBackdrop(ev: MouseEvent): void {
    if (this.closeOnBackdrop && ev.target === ev.currentTarget) this.emitClose();
  }

  emitClose(): void { this.close.emit(); }
}
